import { type SxProps } from '@mui/system'
import React, { type ReactElement } from 'react'
import { Typography, useTheme } from '@mui/material'
import SimpleTooltip from 'common/ui/simple-tooltip'

import styles from './CellInfoWrapper.module.scss'

interface CellWrapperProps {
  title: string
  value?: string
  valueSx?: SxProps
  style?: React.CSSProperties
  width?: string
}

const TooltipCellWrapper: React.FC<CellWrapperProps> = ({
  title,
  value,
  valueSx,
  width,
  style,
}): ReactElement => {
  const { palette } = useTheme()

  return (
    <div className={styles.cellInfoWrapper} style={{ width }}>
      <div className={styles.info}>
        <Typography variant="subtitle1" sx={{ color: palette.gray.main }}>
          {title}
        </Typography>
        <div className={styles.tooltipWrapper}>
          <SimpleTooltip title={value ?? ''} style={{ textAlign: 'left' }}>
            <Typography variant="title3" sx={valueSx} className={styles.value} style={style}>
              {value}
            </Typography>
          </SimpleTooltip>
        </div>
      </div>
    </div>
  )
}

export default TooltipCellWrapper
